import { Sucursal } from "./sucursal";

export class Bodega{
	constructor(
		public id: String = "",
		public nombre: String = "",
		public status: String = "",
		public empresa_id: String = "",
		public sucursal_id: String = "",
		public usuario_id: String = null,
		//public usuario_elim_id: String = ""

		public sucursal: Sucursal = new Sucursal(),
	){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/bodega.ts